import React, { useEffect } from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import Unibrow from 'js/design_system/Unibrow';
import { recordShow } from 'js/utils/dismissibles';
import Timer from './Timer';
import useDiscountDuration from './useDiscountDuration';

import type { SeasonalDiscountUnibrowProps } from 'js/unibrows/types';
import _TimerGroup from "SeasonalDiscountUnibrow-TimerGroup.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/unibrows/seasonal_discount_unibrow/SeasonalDiscountUnibrow.tsx?styleId=TimerGroup";
import _Message from "SeasonalDiscountUnibrow-Message.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/unibrows/seasonal_discount_unibrow/SeasonalDiscountUnibrow.tsx?styleId=Message";
import _MinibrowContent from "SeasonalDiscountUnibrow-MinibrowContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/unibrows/seasonal_discount_unibrow/SeasonalDiscountUnibrow.tsx?styleId=MinibrowContent";
import _MinibrowTextBlock from "SeasonalDiscountUnibrow-MinibrowTextBlock.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/unibrows/seasonal_discount_unibrow/SeasonalDiscountUnibrow.tsx?styleId=MinibrowTextBlock";
import _MinibrowSubtitle from "SeasonalDiscountUnibrow-MinibrowSubtitle.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/unibrows/seasonal_discount_unibrow/SeasonalDiscountUnibrow.tsx?styleId=MinibrowSubtitle";
import _MinibrowTitle from "SeasonalDiscountUnibrow-MinibrowTitle.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/unibrows/seasonal_discount_unibrow/SeasonalDiscountUnibrow.tsx?styleId=MinibrowTitle";


type MinibrowProps = {
  className?: string;
  // End month and day as a timestamp or in the form "MM/DD", no year
  endDate?: string;
};

const TimerGroup = /*#__PURE__*/styled("div", null, {
  displayName: "TimerGroup",
  styles: _TimerGroup
});

const Message = /*#__PURE__*/styled("h3", null, {
  displayName: "Message",
  styles: _Message
});

const MinibrowContent = /*#__PURE__*/styled("div", null, {
  displayName: "MinibrowContent",
  styles: _MinibrowContent
});

const MinibrowTextBlock = /*#__PURE__*/styled("div", null, {
  displayName: "MinibrowTextBlock",
  styles: _MinibrowTextBlock
});

const MinibrowSubtitle = /*#__PURE__*/styled("h2", null, {
  displayName: "MinibrowSubtitle",
  styles: _MinibrowSubtitle
});

const MinibrowTitle = /*#__PURE__*/styled("h1", null, {
  displayName: "MinibrowTitle",
  styles: _MinibrowTitle
});

export const SeasonalDiscountMinibrow = ({
  className,
  endDate,
}: MinibrowProps) => {
  const duration = useDiscountDuration(endDate);

  useEffect(() => {
    recordShow('SeasonalDiscountMinibrow');
  }, []);

  return (
    <div>
      <MinibrowContent className={className}>
        <MinibrowTextBlock>
          <MinibrowSubtitle>Limited Time</MinibrowSubtitle>
          <MinibrowTitle>Offer ends soon</MinibrowTitle>
        </MinibrowTextBlock>
        <Timer startDuration={duration} mini />
      </MinibrowContent>
    </div>
  );
};

const SeasonalDiscountUnibrow = ({
  couponCode,
  lctDiscountVariant,
  endDate,
  feature,
  trigger,
  trialDays,
  trialPrice,
  couponAmount,
}: SeasonalDiscountUnibrowProps) => {
  const duration = useDiscountDuration(endDate);
  const isLctNoDiscount = lctDiscountVariant === 'lct_no_discount';

  const interpolateCopy = (copy: string) =>
    copy
      .replace('{TRIAL_DAYS}', trialDays?.toString() ?? '')
      .replace('{TRIAL_PRICE}', trialPrice ?? '')
      .replace('{COUPON_PERCENT}', couponAmount?.toString() ?? '');

  const discountCopy = interpolateCopy(
    isLctNoDiscount
      ? 'Academia Premium {TRIAL_DAYS} day trial for just {TRIAL_PRICE}'
      : '{COUPON_PERCENT}% OFF ACADEMIA PREMIUM',
  );
  const limitedTimeCopy = interpolateCopy(
    isLctNoDiscount ? 'Don\u2019t forget:' : 'Limited Time',
  );
  const endingSoonCopy = isLctNoDiscount ? '' : 'OFFER ENDS SOON';
  const ctaCopy = interpolateCopy(
    isLctNoDiscount ? 'Upgrade now for {TRIAL_PRICE}' : 'Upgrade Now',
  );
  const hideTimer = isLctNoDiscount;

  const handleClick = () => {
    const url = couponCode
      ? routes.upgrade_url({
          feature,
          trigger,
          premium_discount_coupon: couponCode,
        })
      : routes.upgrade_url({
          feature,
          trigger,
        });
    window.location.href = url;
  };

  const timerContent = !hideTimer ? (
    <TimerGroup>
      <Message>{endingSoonCopy}</Message>
      <Timer startDuration={duration} />
    </TimerGroup>
  ) : undefined;

  return (
    <Unibrow
      dismissibleName="SeasonalDiscountUnibrow"
      eyebrowIcon="campaign"
      eyebrowText={limitedTimeCopy}
      text={discountCopy}
      primaryButton={{ text: ctaCopy, onClick: handleClick }}
      content={timerContent}
    />
  );
};

export default SeasonalDiscountUnibrow;
